export const GET_COMPANY_WORKING_LOGS_REQUEST = "GET_COMPANY_WORKING_LOGS_REQUEST";
export const GET_COMPANY_WORKING_LOGS_RESPONSE = "GET_COMPANY_WORKING_LOGS_RESPONSE";

export const GET_COMPANY_WORKING_SLOTS_REQUEST = "GET_COMPANY_WORKING_SLOTS_REQUEST";
export const GET_COMPANY_WORKING_SLOTS_RESPONSE = "GET_COMPANY_WORKING_SLOTS_RESPONSE";
export const ADD_COMPANY_WORKING_SLOT = "ADD_COMPANY_WORKING_SLOT";
export const EDIT_COMPANY_WORKING_SLOT_REQUEST = "EDIT_COMPANY_WORKING_SLOT_REQUEST";
export const DELETE_COMPANY_WORKING_SLOT_REQUEST = "DELETE_COMPANY_WORKING_SLOT_REQUEST";

export const GET_COMPANY_TRAINING_WORKING_SLOTS_REQUEST =
  "GET_COMPANY_TRAINING_WORKING_SLOTS_REQUEST";
export const GET_COMPANY_TRAINING_WORKING_SLOTS_RESPONSE =
  "GET_COMPANY_TRAINING_WORKING_SLOTS_RESPONSE";
export const ADD_COMPANY_TRAINING_WORKING_SLOT = "ADD_COMPANY_TRAINING_WORKING_SLOT";
export const EDIT_COMPANY_TRAINING_WORKING_SLOT_REQUEST =
  "EDIT_COMPANY_TRAINING_WORKING_SLOT_REQUEST";
export const DELETE_COMPANY_TRAINING_WORKING_SLOT_REQUEST =
  "DELETE_COMPANY_TRAINING_WORKING_SLOT_REQUEST";
